"use strict";

exports.__esModule = true;
exports.default = getMaxKernelSize;
function getMaxKernelSize(gl) {
    var maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    var kernelSize = 15;

    while (kernelSize > maxVaryings) {
        kernelSize -= 2;
    }

    return kernelSize;
}
//# sourceMappingURL=getMaxBlurKernelSize.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pixi.js/lib/filters/blur/getMaxBlurKernelSize.js
// module id = 301
// module chunks = 0